import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Warning from "./warning";

import { EMPTY_WARNING } from "../lib/constants";
import { getPicklist } from "../../nutritionpanel/lib/data";

const Warnings = (props) => {
    const [warnings, setWarnings] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const response = await getPicklist("DrugWarnings");

            if (!response) {
                return;
            }

            setWarnings(response);
        }

        fetchData();
    }, []);

    const addNew = () => {
        props.addItem("warnings", { ...EMPTY_WARNING });
    };
    const updateItems = (value) => {
        props.updateOnChange("warnings", value);
    };
    const warningList = props.data.map((warning) => {
        return (
            <Warning
                key={warning.key}
                id={warning.key}
                data={warning}
                warningList={warnings}
                removeItem={props.removeItem}
                updateOnChange={updateItems}
            />
        );
    });

    return (
        <div>
            <h3>Warnings</h3>
            {warningList}
            <button className="button -primary -small" onClick={addNew}>
                <FontAwesomeIcon icon={faPlus} /> Warning
            </button>
        </div>
    );
};

export default Warnings;
